import {IDotRezSellSeatRequest} from "../../data-contracts/requests/booking/sell-seat.request";
import {DotRezGraphQLMutationBuilder} from "../dot-rez-query-builder";

export function sellSeatGraphqlMutation(request: IDotRezSellSeatRequest, queryBuilder: DotRezGraphQLMutationBuilder): DotRezGraphQLMutationBuilder {

    queryBuilder.addMutation(`
            mutation sellSeat($passengerKey: String 
                      $seatKey: String,
                      $request: Input_AddSeatRequest) {
                seatAddv2(passengerKey: $passengerKey 
                          unitKey: $seatKey
                          request: $request) {
                    unitKey
                }
            }`,
        {
            name: 'passengerKey',
            value: request.passengerKey
        },
        {
            name: 'seatKey',
            value: request.seatKey
        },
        {
            name: 'request',
            value: {
                journeyKey: request.journeyKey,
                waiveFee: request.waiveFee || false
            }
        });

    return queryBuilder;
}
